/**
 * Avvisi NON bloccanti emessi dopo una riassegnazione cliente riuscita (R6-C).
 *
 * Segnalano ciò che la riassegnazione NON ha toccato di proposito: documenti
 * già intestati al cliente precedente, produttore materializzato rimasto
 * agganciato al soggetto vecchio, conferimenti staccati da una bozza.
 * Nessuno di questi blocca l'operazione: sono il presidio informativo che
 * rende esplicito lo stato ibrido subito dopo il cambio.
 */
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { AvvisoRiassegnazione } from '../api/richieste';

interface Props {
  avvisi: AvvisoRiassegnazione[];
  onDismiss: () => void;
}

export default function AvvisiRiassegnazione({ avvisi, onDismiss }: Props) {
  const { t } = useTranslation();
  if (avvisi.length === 0) return null;

  return (
    <div
      data-testid="avvisi-riassegnazione"
      className="rounded-lg border border-accent-warning/30 bg-accent-warning-bg px-4 py-3"
    >
      <div className="flex items-start gap-2.5">
        <AlertTriangle size={16} className="text-accent-warning flex-shrink-0 mt-0.5" />
        <div className="flex-1 space-y-2">
          <p className="text-sm font-medium text-ink-dark">
            {t('richieste.cambia_cliente.avvisi.titolo')}
          </p>
          <ul className="space-y-1.5">
            {avvisi.map((a) => (
              <li key={a.codice} className="text-sm text-ink-dark">
                {t(`richieste.cambia_cliente.avvisi.${a.codice}`)}
                {a.dettagli.length > 0 && (
                  <span className="block text-xs text-ink-soft mt-0.5">{a.dettagli.join(' · ')}</span>
                )}
              </li>
            ))}
          </ul>
        </div>
        <button type="button" onClick={onDismiss}
          className="text-xs text-ink-soft hover:text-ink-dark transition-colors flex-shrink-0">
          {t('common.azioni.chiudi')}
        </button>
      </div>
    </div>
  );
}
